import React from 'react';
import { motion } from 'framer-motion';
export function AttorneyProfile() {
  return <section id="attorney" className="py-16 md:py-24 bg-white" data-id="element-9">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center" data-id="element-11">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-5/12 relative" data-id="element-12">
            <div className="absolute inset-0 bg-[#c9a35a] translate-x-4 translate-y-4 z-0" data-id="element-13" />
            <img src="https://cdn.magicpatterns.com/uploads/vdQ29rueULyPifkkfM3dxC/photo_2026-06-27_14-11-16.jpg" alt="Michael Stufflebeam, Attorney at Law" className="relative z-10 w-full h-[380px] sm:h-[480px] lg:h-[600px] object-cover object-top shadow-2xl" data-id="element-14" />
          </motion.div>

          {/* Content Column */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-7/12" data-id="element-15">
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-[#1a1a1a] font-bold mb-2" data-id="element-16">
              Michael Stufflebeam
            </h2>
            <p className="text-[#7c0a0a] font-semibold tracking-widest uppercase mb-6" data-id="element-17">
              Founding Partner & Lead Attorney
            </p>

            <div className="space-y-6 text-gray-600 text-lg leading-relaxed" data-id="element-18">
              <p data-id="element-19">
                For over three decades, Michael Stufflebeam has been a
                formidable presence in Southern California courtrooms. As a
                former prosecutor and highly respected trial attorney, he brings
                an unparalleled depth of experience to every case he handles.
              </p>
              <p data-id="element-20">
                Mr. Stufflebeam's philosophy is simple: every client deserves
                aggressive, intelligent, and compassionate representation.
                Whether navigating a complex high-net-worth divorce, defending
                against serious criminal charges, or securing compensation for
                the injured, his approach is always tailored to achieve the best
                possible outcome.
              </p>
              <p data-id="element-21">
                With deep roots in the Hermosa Beach community, Mr. Stufflebeam
                has built a firm that reflects his commitment to excellence,
                assembling a team of dedicated legal professionals who share his
                vision for justice.
              </p>
            </div>

            <div className="mt-10 flex flex-wrap gap-4" data-id="element-22">
              <div className="border-l-4 border-[#c9a35a] pl-4" data-id="element-23">
                <p className="font-serif text-3xl font-bold text-[#1a1a1a]" data-id="element-24">
                  30+
                </p>
                <p className="text-sm text-gray-500 uppercase tracking-wider" data-id="element-25">
                  Years Experience
                </p>
              </div>
              <div className="border-l-4 border-[#c9a35a] pl-4 ml-0 md:ml-8" data-id="element-26">
                <p className="font-serif text-3xl font-bold text-[#1a1a1a]" data-id="element-27">
                  10k+
                </p>
                <p className="text-sm text-gray-500 uppercase tracking-wider" data-id="element-28">
                  Cases Handled
                </p>
              </div>
            </div>

            <div className="mt-10" data-id="element-29">
              <span className="text-4xl text-[#1a1a1a]/70 italic" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-30">
                Michael Stufflebeam
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}